module.exports = __webpack_public_path__ + "static/media/intro_mood.0674bfb3.png";